import { StyleSheet } from "@react-pdf/renderer";
import { blue } from "./PDFColors";

export const styles = StyleSheet.create({
  containerCenter: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  containerLeftBottom: {
    position: "absolute",
    left: "0%",
    bottom: "0%",
    padding: "15px",
  },
  containerRightBottom: {
    position: "absolute",
    right: "0%",
    bottom: "0%",
    padding: "15px",
  },
  logo: {
    width: "250px",
  },

  text: { textAlign: "left", fontSize: "12px", marginBottom: "4px" },
  link: {
    color: blue,
  },
});
